import {CONTENT_TYPE_TEXT, CONTENT_CATEGORY_OPTION, CONTENT_CONTACT_LINK} from '../../constants';

export default {
  id: 'MOD_MAND_OPERA',
  title: 'Comment puis-je diffuser mes documents auprès des autres plateformes du réseau OnceForAll ?',
  description: '',
  categories: [CONTENT_CATEGORY_OPTION],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Quelle que soit votre offre déposante, vous bénéficiez de la possibilité de diffuser votre dossier administratif sur l\'ensemble du réseau OnceForAll : Actradis, Hiveo et Déclarations Légales.'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Pour en profiter, contactez notre service client directement depuis'
  },
  {
    type: CONTENT_CONTACT_LINK,
    label: 'cette page'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'et choisissez la rubrique « Mon Offre »'
  }]
};
